import clsx from "clsx";
import { useT } from "../i18n";
import { ToneMarker } from "./StatusBadge";
import type { Tone } from "./statusMap";

export type ConflictMode = "prevent" | "detect" | "mitigated";
const toneOfMode: Record<ConflictMode, Tone> = { prevent: "bad", detect: "warn", mitigated: "neutral" };

/**
 * Inline SoD sentence with a marker (§2.4). Always names the other side:
 * "Conflicts with ERP Accounts Payable Clerk, which Michael has." Used in catalogue, approvals and reviews.
 */
export function ConflictNote({ mode, otherSide, holder, until, className }: { mode: ConflictMode; otherSide: string; holder: string; until?: string; className?: string }) {
  const t = useT();
  const tone = toneOfMode[mode];
  const text = t(`conflict.${mode}`, { otherSide, holder, until: until ?? "–" });
  return (
    <span className={clsx("inline-flex items-start gap-2 text-small", className)}>
      <span className={clsx("mt-[4px] inline-flex", tone === "bad" ? "text-bad" : tone === "warn" ? "text-warn" : "text-neutral")}><ToneMarker tone={tone} /></span>
      <span className={clsx(tone === "bad" ? "text-bad font-semibold" : "text-fg-2")}>{text}</span>
    </span>
  );
}
